import * as React from 'react'
import type {SVGProps} from 'react'
const ChevronDown = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={15}
        height={9}
        viewBox="0 0 15 9"
        fill="#142745"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8958 0.408C13.3228 -0.136 12.3937 -0.136 11.8227 0.408L7.16275 4.831L2.50175 0.408C1.92975 -0.136 1.00175 -0.136 0.42975 0.408C-0.14325 0.952 -0.14325 1.834 0.42975 2.377L7.16475 8.764L13.8947 2.377C14.4677 1.834 14.4677 0.952 13.8947 0.408"
        />
    </svg>
)
export default ChevronDown
